export default __webpack_public_path__ + "static/media/332.8f7c4d19.png";